import isAbsolutePath from './is-absolute-path';
const checkIfUrlHasSameDomain = (currentDomain, sanitizedUrl) => {
  if (!isAbsolutePath(sanitizedUrl)) return true;
  if (!currentDomain || !sanitizedUrl) return false;
  return sanitizedUrl.includes(currentDomain);
};
export default checkIfUrlHasSameDomain;
//# sourceMappingURL=check-if-url-has-same-domain.js.map